module.exports = __webpack_public_path__ + "49bc5c2246f74fd7c659267027022f43.jpg";